import { render, staticRenderFns } from "./videoStyle.vue?vue&type=template&id=2e510258&scoped=true"
import script from "./videoStyle.vue?vue&type=script&lang=js"
export * from "./videoStyle.vue?vue&type=script&lang=js"
import style0 from "./videoStyle.vue?vue&type=style&index=0&id=2e510258&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e510258",
  null
  
)

export default component.exports